import type { OrganizationQuery } from '@innovamat/glow-api-client';
import { useOrganizationQuery } from '@innovamat/glow-api-client';
import type { QueryClient } from '@tanstack/react-query';
import { getSchoolTeachersQueryKey } from '../hooks/use-school-teachers';
import type { OrganizationTeacher } from '../modules/teacher';

type DeleteTeacher = {
  queryClient: QueryClient;
  teacherId: string;
  organizationId: string;
  isInvitation: boolean;
  isPlatformEnabled: boolean;
};

function deleteTeacherInCache({
  queryClient,
  teacherId,
  organizationId,
  isInvitation,
  isPlatformEnabled,
}: DeleteTeacher): void {
  const key = getSchoolTeachersQueryKey({
    organizationId,
    isPlatformEnabled,
  });

  const data = queryClient.getQueryData<{
    teachers?: Array<OrganizationTeacher | null> | null;
  }>(key);

  if (data) {
    const newData = data.teachers?.filter(
      (_teacher) => _teacher?.id !== teacherId
    );

    queryClient.setQueryData(key, {
      teachers: newData,
    });
  }

  if (!isInvitation) {
    const organizationKey = useOrganizationQuery.getKey({
      id: organizationId,
    });

    const organization =
      queryClient.getQueryData<OrganizationQuery>(organizationKey);

    if (organization?.organization?.numberOfTeachers) {
      queryClient.setQueryData<OrganizationQuery>(organizationKey, {
        organization: {
          ...organization.organization,
          numberOfTeachers: organization.organization?.numberOfTeachers - 1,
        },
      });
    }
  }
}

export { deleteTeacherInCache };
